module.exports = __webpack_public_path__ + "libra-d83246cb3943c6675c54.png";